import { Box, Button, Chip, Divider, Hidden, Typography } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import IncidentReportDetail from 'components/incident-reports/incident-report-detail'
import NivosModal from 'components/nivos-modal'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { IncidentReport } from 'types/incident-report'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
  }
}

interface OwmProps {
  report: IncidentReport
}

type AppProps = StateProps & DispatchProps & OwmProps

const IncidentReportCardFC: React.FC<any> = (props: AppProps) => {
  const { report, layout } = props
  const [open, setOpen] = React.useState(false)
  return (
    <Box
      width={0.9}
      padding={1}
      marginBottom={1}
      border={1}
      borderRadius={'12px'}
      sx={{
        marginRight: 'auto',
        marginLeft: 'auto',
        transition: '.25s'
      }}
    >
      <NivosModal title={report.title} open={open} setOpen={setOpen}>
        <IncidentReportDetail />
      </NivosModal>
      <Hidden smDown>
        <Box>
          <Box display={'flex'}>
            <Typography variant={'h5'} flexGrow={1}>
              {report.title}
            </Typography>
            <Box display={'flex'} alignItems={'center'}>
              <Typography variant={'body2'} marginRight={1}>
                <strong>{layout.language.translations.status}</strong>:{' '}
              </Typography>
              <Chip
                variant={'filled'}
                label={report.status}
                size={'small'}
                sx={{
                  minWidth: '93px'
                }}
              />
            </Box>
          </Box>
          <Divider />
          <Box width={1} display={'flex'}>
            <Box flexGrow={1}>
              <Typography variant={'body2'}>
                <strong>{layout.language.translations.reporter}</strong>:{' '}
                {report.createdBy.fullName}
              </Typography>
              <Typography variant={'body2'}>
                <strong>Date</strong>: {report.createdAt.toUTCString()}
              </Typography>
            </Box>
            <Box paddingTop={1}>
              <Button
                variant={'contained'}
                color={'primary'}
                size={'small'}
                onClick={() => setOpen(true)}
              >
                {layout.language.translations.details}
              </Button>
            </Box>
          </Box>
        </Box>
      </Hidden>
      <Hidden smUp>
        <Box>
          <Box display={'flex'}>
            <Typography variant={'h5'} flexGrow={1}>
              {report.title}
            </Typography>
            <Chip
              variant={'filled'}
              label={report.status}
              size={'small'}
              sx={{
                minWidth: '93px'
              }}
            />
          </Box>
          <Divider />
          <Box width={1} display={'flex'}>
            <Box paddingTop={1}>
              <Button
                variant={'contained'}
                color={'primary'}
                size={'small'}
                onClick={() => setOpen(true)}
              >
                {layout.language.translations.details}
              </Button>
            </Box>
          </Box>
        </Box>
      </Hidden>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations
})

const IncidentReportCard = connect(
  mapStateToProps,
  mapDispatchToProps
)(IncidentReportCardFC) as React.FC<OwmProps>

export default IncidentReportCard
